import gql from 'graphql-tag';

export default gql`
  fragment fullPublication on Publication {
    metadata {
      identifier
      title
      language
      published
      publisher {
        name
      }
      subject {
        code
      }
      description
      author {
        name
      }
    }
    links {
      rel
      href
      type
    }
    images {
      type
      href
      width
      height
    }
    licenses {
      metadata {
        identifier
        format
        price {
          currency
          value
        }
        terms {
          checkouts
          lifetime
          concurrency
          length
        }
      }
    }
  }
`;
